import { Card, Dropdown, Menu } from "antd";
import React from "react";
import { EllipsisOutlined } from "@ant-design/icons";

function OutletCard({ area, address, onEdit, onDelete = () => {} }) {
  const menu = (data) => {
    return (
      <Menu>
        <Menu.Item
          style={{
            width: "150px",
          }}
          key="edit"
          onClick={onEdit}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          style={{
            width: "150px",
          }}
          key="delete"
          onClick={onDelete}
        >
          Delete
        </Menu.Item>
      </Menu>
    );
  };
  return (
    <Card
      style={{
        border: "1px solid #D0D5DD",
        borderRadius: "1rem",
        position: "relative",
        height: 180,
      }}
    >
      <div
        style={{
          textAlign: "right",
          position: "absolute",
          right: "1rem",
          top: "1rem",
        }}
      >
        <Dropdown overlay={menu()} placement="bottom" arrow>
          <EllipsisOutlined
            style={{
              fontSize: "2rem",
              transform: "rotate(90deg)",
              cursor: "pointer",
            }}
          />
        </Dropdown>
      </div>
      <h6
        style={{
          marginTop: "2rem",
        }}
      >
        {area}
      </h6>
      <p
        style={{
          color: "#99999F",
        }}
      >
        {address}
      </p>
    </Card>
  );
}

export default OutletCard;
